import { validateUrls } from "api/types"

export const urls = validateUrls({
  getCalendarSchedule: () => "/attendance/class-schedules/",
  getClassOverview: classId => `/attendance/class-schedules/${classId}/users/`,
  markAttendance: userId => `/attendance/${userId}/`,
})
